import dayjs from 'dayjs';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parse a value into a dayjs instance, treating date-only strings
 * ("YYYY-MM-DD") as LOCAL midnight rather than UTC midnight.
 *
 * Passing a bare date-only string to dayjs()/Date() interprets it as UTC, which
 * then renders/compares as the previous day for viewers west of UTC
 * (e.g. "2026-01-01" -> "Dec 31, 2025" in US timezones). Appending a local time
 * component keeps the calendar date intact regardless of the viewer's timezone.
 *
 * Full timestamps (with time/zone, e.g. createdAt) are passed through unchanged.
 */
export const parseLocalDate = (date: dayjs.ConfigType): dayjs.Dayjs => {
  if (typeof date === 'string' && DATE_ONLY_REGEX.test(date)) {
    return dayjs(`${date}T00:00:00`);
  }
  return dayjs(date);
};

export const formatDate = (date: string, format: string = 'MMM DD, YYYY') => {
  return parseLocalDate(date).format(format);
};
